export default class PartnershipTypes {
  static balanced = 'BALANCED';
  static imbalanced = 'IMBALANCED';
  static overloading = 'OVERLOADING';

  static overlapping = 'overlapping';
  static direct = 'direct';
}
